module.exports = __webpack_public_path__ + "media/images/lps-vs_graph_sp-30ec78ea.png";